
<div class="row" style="margin-top: -75px;">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="divContainer" style="margin:10px 10px;">
          <h4>Hello {{LoginName}},</h4>

          <div style="line-height:30px;">
            We notice that you have an AAAS Azure id but no rights in the SesameWms system. Please contact the SesameWms administrators to assign a role for you to login.
            <br />
            Administrators of the SesameWms system are
            <br />
            <div><a href="mailto:jhillman@aaas.org"> a. Jason Hillman (jhillman@aaas.org)</a></div>
            <div>
              <a href="mailto:rfranz@aaas.org">  b. Rebecca Franz (rfranz@aaas.org)</a>
            </div>
          </div>
          <br />
          Thank you

        </div>
      </div>
    </div>
  </div>
</div>
